<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" title="可调拨商品" :width="800" :index="0" @hide="hide"
		@submit="submit" moduleName="proofbill" :store="store" selectType="checkbox" @boxdataload="boxdataload"
		:footerButton="footerButton" />
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				footerButton: ['submit', 'cancle'],
				boxConfig: {
					columns: [{
						field: 'skuCode',
						title: '商品编码',
					}, {
						field: 'goodsName',
						title: '商品名称',
					}, {
						field: 'skuName',
						title: '规格',
					}, {
						field: 'size',
						title: '调拨数量',
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: false,
						pageSizes: [10, 20, 50, 200],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show
			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		methods: {
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list() {
				if(this.data.length){
					return Promise.resolve({list:this.data})
				}else{
					return new Promise((resolve, reject) => {
						this.$api.purchase.checkInventoryGoods({
							filtertype: [1,2]
						}).then((res) => {
							resolve({list:res.hasQuantity})
						}, () => {
							reject()
						})
					})
				}

			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>